import { getElementSettings } from '../helpers/registered-settings';

const findAllFor = (element, triggerType) => {
  const settings = getElementSettings();

  return settings.filter(
    (setting) => setting.matches(element, setting.settings) && setting.triggerOn === triggerType
  );
};

export default findAllFor;
